const accordions = document.querySelectorAll(".ft-Accordion");

accordions.forEach((accordion) => {
    accordion.addEventListener("click", function () {
        const panel = this.nextElementSibling;
        this.classList.toggle("ft-Accordion-active");

        if (this.classList.contains("ft-Accordion-active")) {
            panel.style.maxHeight = panel.scrollHeight + "px";
        } else {
            panel.style.maxHeight = null;
        }

        accordions.forEach((acc) => {
            if (acc !== this) {
                acc.classList.remove("ft-Accordion-active");
                acc.nextElementSibling.style.maxHeight = null;
            }
        });
    });
});
